'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _connect = require('react-redux/lib/connect/connect');var _connect2 = _interopRequireDefault(_connect);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxPagan = require('redux-pagan');
var _countries = require('../../redux/modules/countries');
var _components = require('../../components');
var _constants = require('../../constants');
var _foreignPropertySearch = require('../../redux/modules/foreignPropertySearch');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

CountriesListContainer = function (_Component) {_inherits(CountriesListContainer, _Component);function CountriesListContainer() {var _temp, _this, _ret;_classCallCheck(this, CountriesListContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      isShowAllItems: false }, _this.










    clearSearchedAddress = function () {
      _this.props.saveSearchedForeignAddress(null);
    }, _this.

    toggleVisibilityCountriesList = function () {
      _this.setState({ isShowAllItems: !_this.state.isShowAllItems });
    }, _temp), _possibleConstructorReturn(_this, _ret);}CountriesListContainer.prototype.componentDidMount = function componentDidMount() {var _props$countriesList = this.props.countriesList,_props$countriesList$ = _props$countriesList.data,data = _props$countriesList$ === undefined ? [] : _props$countriesList$,loading = _props$countriesList.loading;if (!loading) {this.props.loadCountries();}};CountriesListContainer.prototype.

  render = function render() {var _props =
    this.props,countriesList = _props.countriesList,translate = _props.translate,locale = _props.locale,isMobile = _props.isMobile;var
    isShowAllItems = this.state.isShowAllItems;

    var dataItems = countriesList.data || [];
    var count = _constants.COUNTRIES_LIST['COUNT_COUNTRY_IN_LIST' + (isMobile ? '_MOBILE' : '')];
    var countriesData = isShowAllItems ? dataItems : dataItems.slice(0, count);
    var isVisibleBtn = dataItems.length > count;

    var buttonTextShowLess = translate('countriesList', 'buttonLess');
    var buttonTextShowAll = translate('countriesList', 'buttonMore');

    return (
      _react2.default.createElement(_components.CountriesList, {
        countriesData: countriesData,
        toggleVisibilityCountriesList: this.toggleVisibilityCountriesList,
        buttonText: '' + (isShowAllItems ? buttonTextShowLess : buttonTextShowAll),
        locale: locale,
        isVisibleBtn: isVisibleBtn,
        clearSearchedAddress: this.clearSearchedAddress }));


  };return CountriesListContainer;}(_react.Component);


CountriesListContainer.propTypes = {
  countriesList: _propTypes2.default.object,
  loadCountries: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  saveSearchedForeignAddress: _propTypes2.default.func };


var mapStateToProps = function mapStateToProps(state) {return {
    countriesList: state.countries,
    isMobile: state.windowDimentions.isMobile,
    locale: state.lang.locale,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static') };};exports.default =


(0, _connect2.default)(mapStateToProps, {
  loadCountries: _countries.loadCountries,
  saveSearchedForeignAddress: _foreignPropertySearch.saveSearchedForeignAddress })(
CountriesListContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/CountriesListContainer/CountriesListContainer.js
// module id = 2958
// module chunks = 0